import { Input, Select, TextArea } from 'common/InputForm';
import { CustomModal, PopupModal } from 'components/modals/ModalBox';
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useState } from 'react'
import { changeOrderStatusApi } from 'services/orderManagement';
import { deliveryStatusValue } from 'utils/componentValue/MasterValue';

const ChangeOrderStatus = ({ show, close, data, listing = () => { }, orderId, orderDetails }) => {
      console.log('data', data)
    const [error, setError] = useState({});
    const [buttonLoader, setButtonLoader] = useButtonLoader("submit");
    const [confirmModal, setConfirmModal] = useState(false)

    const [input, setInput] = useState({
        status: "",
        reason: '',
        partnerName: "",
        partnerNumber: ""

    })
    const usedStatuses = Array.isArray(data?.orderStatusDetails)
        ? data?.orderStatusDetails.map(item => item.status) || []
        : [];
  console.log('usedStatuses', usedStatuses)

    // -----------handle-close----------------
    const modalClose = (e) => {
        close()
        setInput({ status: "", reason: '', partnerName: "", partnerNumber: "" })
        setError({})
    };
    // -----------modal-onchange----------------
    const handleChange = (e) => {
        const { name, value } = e.target;
        const noLeadSpace = value.replace(/^\s+/, '');
        if (name === 'status') {
            // console.log('first')
            setInput({ ...input, [name]: noLeadSpace, reason: '', partnerName: "", partnerNumber: "" });
        } else if (name === "partnerNumber") {
            let newValue = value.replace(/(?!^-)\D+/g, "");

            if (newValue.length > 10) {
                newValue = newValue.slice(0, 10);
            }

            setInput({ ...input, [name]: newValue });
        } else {
            setInput({ ...input, [name]: noLeadSpace });
        }
    };
    // ------------validation-----------------
    const validation = () => {
        let errorMessage = {};
        let status = true;

        if (!input.status) {
            errorMessage['status'] = 'Please Select status';
            status = false;
        }

        if (input?.status === 'CANCELLED' && !input.reason) {
            errorMessage['reason'] = 'Please enter Reject Reason';
            status = false;
        }

        if (input?.status === 'OUT_FOR_DELIVERY' && !input.partnerName) {
            errorMessage['partnerName'] = 'Please enter Partner Name';
            status = false;
        }

        if (input?.status === 'OUT_FOR_DELIVERY' && !input.partnerNumber) {
            errorMessage['partnerNumber'] = 'Please enter Partner Number';
            status = false;
        } else if (input?.status === 'OUT_FOR_DELIVERY' && input.partnerNumber && input.partnerNumber.length < 10) {
            errorMessage['partnerNumber'] = 'Partner Number must be 10 digits';
            status = false;
        }



        setError(errorMessage);
        return status;
    };

    const handleClick = (status) => {
          console.log('click handleClick',status)
        if (status === 'CANCELLED') {
            setConfirmModal(true)
        } else {
            //   console.log('click changeStatus',status)
            changeStatus()
        }
    }
    // ------------add-API--------------------
    const changeStatus = async () => {
        console.log('click changeStatus')
        if (validation()) {
            try {
                const payLoad = {
                    userId: data?.user?._id,
                    orderId,
                    status: input?.status || '',
                    ...(input?.reason && { reason: input.reason }),
                    ...(input?.partnerName && input?.partnerNumber && {
                        deliveryPartnerName: input.partnerName,
                        deliveryPartnerMobile: input.partnerNumber,
                    }),
                };

                
                setButtonLoader(true)
                const res = await changeOrderStatusApi(payLoad)
                const { code, message } = res?.data;
                if (code === 200) {
                    // toastMessage(message, 'success', 'addPromoCode')
                    setConfirmModal(false)
                    listing()
                    modalClose()
                }
            } catch (e) {
                console.log('e', e)
            } finally {
                setButtonLoader(false)
            }
        }
    }

    const getDeliveryStatusValues = (orderType) => {
        console.log('orderType', orderType)
        const base = [
            { _id: "ACCEPTED", name: "Accepted" },
            { _id: "PROCESSING", name: "Processing" },
            { _id: "DELIVERED", name: "Delivered" },
            { _id: "CANCELLED", name: "Cancelled" },
        ];

        // Insert conditional status
        if (orderType === "PICKUP") {
            base.splice(2, 0, { _id: "IS_READY_TO_PICK", name: "Is Ready to pickup" });
        } else {
            base.splice(2, 0, { _id: "OUT_FOR_DELIVERY", name: "Out for Delivery" });
        }

        return base;
    };
    return (
        <>
            <CustomModal
                className={"add_model"}
                show={show}
                handleClose={modalClose}
            >
                <h3>Change Status</h3>
                <div className="form_field_wrap">
                    {/* <div className="form_field">
                        <Select
                            type="text"
                            label="Status"
                            name="status"
                            value={input?.status}
                            onChange={handleChange}
                            error={error.status}

                        >
                            <option value="" disabled>select Status</option>
                            {deliveryStatusValue.map(({ _id, name }) => (
                                <option
                                    key={_id}
                                    value={_id}
                                    disabled={usedStatuses.includes(_id)}
                                >
                                    {name}
                                </option>
                            ))}

                        </Select>
                    </div> */}

                    <div className="form_field">
                        <Select
                            type="text"
                            label="Status"
                            name="status"
                            value={input?.status}
                            onChange={handleChange}
                            error={error.status}
                        >
                            <option value="" disabled>
                                Select Status
                            </option>
                            {getDeliveryStatusValues(orderDetails?.orderType).map(({ _id, name }, i) => (
                                <option
                                    key={`${_id}-${i}`}
                                    value={_id}
                                    disabled={usedStatuses.includes(_id)}
                                >
                                    {name}
                                </option>
                            ))}
                        </Select>
                    </div>
                </div>
                {input?.status === 'OUT_FOR_DELIVERY' &&
                    <div className="form_field_wrap">
                        <div className="form_field">
                            <Input
                                label="Delivery Partner Name"
                                placeholder="Delivery Partner Name"
                                name="partnerName"
                                value={input?.partnerName}
                                onChange={handleChange}
                            />

                            {error["partnerName"] && (
                                <div>
                                    <p className="error">{error["partnerName"]}</p>
                                </div>
                            )}
                        </div>
                        <div className="form_field">
                            <Input
                                label="Delivery Partner Number"
                                placeholder="Delivery Partner Number"
                                name="partnerNumber"
                                value={input?.partnerNumber}
                                onChange={handleChange}
                            />

                            {error["partnerNumber"] && (
                                <div>
                                    <p className="error">{error["partnerNumber"]}</p>
                                </div>
                            )}
                        </div>
                    </div>}
                {input?.status === 'CANCELLED' &&
                    <div className="form_field_wrap">
                        <div className="form_field">
                            <TextArea
                                type="text"
                                label="Reject Reason"
                                name="reason"
                                placeholder='Please enter your reason'
                                value={input?.reason}
                                onChange={handleChange}
                                error={error.reason}
                            />
                        </div>
                    </div>}


                <div className="button_wrap">
                    <button
                        type="button"
                        className="button light"
                        onClick={modalClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        ref={buttonLoader}
                        onClick={() => handleClick(input?.status)}
                        className="button"
                    >
                        Submit
                    </button>
                </div>
            </CustomModal>

            <PopupModal
                show={confirmModal}
                handleClose={() => setConfirmModal(false)}
                content="Are you sure you want to cancel the Order?"
                title="Cancel Order"
                buttonLoader={buttonLoader}
                action={changeStatus}
            />
        </>
    )
}

export default ChangeOrderStatus